import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from '../../lib/i18n';
import { setData, useLocalStorage } from '../../lib/storage';
import { trackEvent } from '../../lib/tracking';
import { Button } from '../common/button';
import { ReadMoreLink } from '../common/link';
import { Video } from '../common/video';
import { Container } from '../layout/container';
import Layout from '../layout/layout';
import { DEFAULT_VALUE } from '../slider/slider';
import { useUser } from '../user-context';
import WinePreview from '../wine/preview';
import { WineRating } from './rating';

const Rate = ({ preview, wines }) => {
  const { t } = useTranslation();
  const { user, onAuthenticatedAction, actions } = useUser();

  const { getDegusetRating, setDegusetRatingDefaults, setDegusetRatingItems } =
    useLocalStorage('degusetRating');

  const router = useRouter();

  useEffect(() => {
    const initRatings = wines.reduce(
      (acc, v) => {
        const sku = v.defaultVariant.sku;
        acc[sku] = user?.metadata[sku] || DEFAULT_VALUE;
        return acc;
      },
      { degusetRating: 'preview' },
    );
    setDegusetRatingDefaults(initRatings);
  }, []);

  const onSubmit = async () => {
    trackEvent({
      category: 'rate',
      action: `submit`,
    });
    if (user) {
      await actions.saveDegusetRating();
    } else {
      setData('nextAuthHading', t('rating_authentication_required'), true);
      onAuthenticatedAction('saveDegusetRating');
      return router.push('/profile');
    }
  };

  const storageRatings = getDegusetRating();

  return (
    <Layout preview={preview} robots='noindex'>
      <Container wide={false} className='mt-16 text-center'>
        <h1 className='mb-4'>{t('rateHeading')}</h1>
        <p className='mb-6'>{t('rateDesription')}</p>
        <div className='border-b border-0.3 pb-10'>
          <Video
            width={600}
            trackingLabel='deguset'
            className='mx-auto max-w-xl rounded-lg'
            videoUrl={'https://www.youtube.com/watch?v=LHrU9USSeYg'}
          />
        </div>

        {wines.map((wine, key) => {
          const url = `/bewerten/${wine.slug}`;
          return (
            <div key={key} className='border-b border-0.3 pb-10 pt-8'>
              <WinePreview item={wine} url={url} className='max-w-[360px]' />
              <WineRating
                key={key}
                wine={wine}
                value={storageRatings[wine.defaultVariant.sku]}
                onRate={setDegusetRatingItems}
              />
              <div className='flex flex-col justify-center'>
                <ReadMoreLink
                  href={url}
                  className='mx-auto mt-10'
                  label={t('toWineDescription')}
                />
              </div>
            </div>
          );
        })}
        <div className='mx-auto mt-11 max-w-sm'>
          <Button onClick={onSubmit} filled={true}>
            {t('submitRaing')}
          </Button>
        </div>
      </Container>
    </Layout>
  );
};

export default Rate;
